import { apiUrl } from "utils/urls";

import axios from "axios";

export const getSpace = async () => {
    const { data } = await axios.get(apiUrl("space") + "/");
    return data;
};

export const patchSpace = async (body) => {
    const { data } = await axios.patch(apiUrl("space") + `/${body.space_uuid}`, body.formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
    return data;
};

export const getSpaceMember = async ({ space_uuid, params } = {}) => {
    const { data } = await axios.get(apiUrl("space") + `/${space_uuid}/member`, { params });
    return data;
};

export const postSpaceMemberInvite = async (body) => {
    const { data } = await axios.post(apiUrl("space") + `/${body.space_uuid}/member`, body.data, {
        headers: {
            "Content-Type": "application/json",
        },
    });
    return data;
};

export const patchSpaceMember = async (body) => {
    const { data } = await axios.patch(
        apiUrl("space") + `/${body.space_uuid}/member/${body.space_member_id}`,
        body.formData,
        {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        },
    );
    return data;
};

export const postSpaceMemberInviteAccept = async (body) => {
    const { data } = await axios.post(
        apiUrl("space") + `/${body.space_uuid}/member/${body.space_member_id}/invite-accept`,
        body.data || {},
    );
    return data;
};

export const postSpaceMemberInviteReject = async (body) => {
    const { data } = await axios.post(
        apiUrl("space") + `/${body.space_uuid}/member/${body.space_member_id}/invite-reject`,
        body.data || {},
    );
    return data;
};

export const deleteSpaceMember = async (body) => {
    const { data } = await axios.delete(apiUrl("space") + `/${body.space_uuid}/member/${body.space_member_id}`, {
        data: body.data,
        headers: {
            "Content-Type": "application/json",
        },
    });
    return data;
};

export const getSpaceAIMember = async ({ space_uuid } = {}) => {
    const { data } = await axios.get(apiUrl("space") + `/${space_uuid}/ai-member`);
    return data;
};

export const getSpaceAIMemberActivityType = async ({ space_uuid } = {}) => {
    const { data } = await axios.get(apiUrl("space") + `/${space_uuid}/ai-member/activity-type`);
    return data;
};

export const postSpaceAIMember = async (body) => {
    const isMultipart = body.data instanceof FormData;
    const { data } = await axios.post(apiUrl("space") + `/${body.space_uuid}/ai-member`, body.data || {}, {
        headers: {
            "Content-Type": isMultipart ? "multipart/form-data" : "application/json",
        },
    });
    return data;
};

export const patchSpaceAIMember = async (body) => {
    const isMultipart = body.data instanceof FormData;
    const { data } = await axios.patch(
        apiUrl("space") + `/${body.space_uuid}/ai-member/${body.ai_member_id}`,
        body.data || {},
        {
            headers: {
                "Content-Type": isMultipart ? "multipart/form-data" : "application/json",
            },
        },
    );
    return data;
};

export const deleteSpaceAIMember = async (body) => {
    const { data } = await axios.delete(apiUrl("space") + `/${body.space_uuid}/ai-member/${body.ai_member_id}`);
    return data;
};

export const getSpaceMemberProfiles = async (space_uuid) => {
    const { data } = await axios.get(apiUrl("space") + `/${space_uuid}/member/profile`);
    return data;
};

export const getSpaceActivityHistory = async ({ space_uuid, params, url } = {}) => {
    const activityHistoryUrl = apiUrl("space") + `/${space_uuid}/activity-history`;
    const requestUrl = url ? activityHistoryUrl + new URL(url, activityHistoryUrl).search : activityHistoryUrl;
    const { data } = await axios.get(requestUrl, { params });
    return data;
};

export const getSpaceDashboard = async (space_uuid) => {
    const { data } = await axios.get(apiUrl("space") + `/${space_uuid}/dashboard`);
    return data;
};

export const getSpacePaymentHistory = async ({ space_uuid, params }) => {
    const { data } = await axios.get(apiUrl("space") + `/${space_uuid}/payment`, { params });
    return data;
};

export const postSpacePaymentHistory = async (body) => {
    const { data } = await axios.post(apiUrl("space") + `/${body.space_uuid}/payment`, body.data || {});
    return data;
};

export const postGroupSubscription = async (body) => {
    const { data } = await axios.post(apiUrl("space") + "/group-subscription", body.data || {});
    return data;
};

export const postGroupSubscriptionRollback = async (body) => {
    const { data } = await axios.post(apiUrl("space") + "/group-subscription/rollback", body.data || {});
    return data;
};
